import { ItemId } from "../../../model/datasource";
import { ContentItem } from "../../../model/datasource/item";
import { AnswerEvent, ToggleContextsEvent } from "../../../events";
import { MultipleChoiceAnswer } from "../../../lib/userdata";
import { MathJaxObject } from "mathjax-full/js/components/startup";
import { DisplayItemFrontend } from "./displayitem";

export class MultipleChoiceFrontend<I extends ItemId> extends DisplayItemFrontend<I> {
	displayItemContent(content: ContentItem<I>, bindTarget: EventTarget): void {
		const multipleChoice = document.querySelector('.item .multiplechoice');
		multipleChoice.classList.remove('d-none');
		multipleChoice.classList.add('invisible');

		const name = multipleChoice.querySelector('.name');
		const prompt = multipleChoice.querySelector('.prompt');
		const style = multipleChoice.querySelector('style');
		name.innerHTML = content.name + '.';
		prompt.innerHTML = content.multiplechoice.prompt;
		style.innerText = [].concat(
			content.multiplechoice.style,
			content.contexts.map(c => c.style),
		).join('\n\n');

		Array.from(multipleChoice.querySelectorAll('.context-panel')).slice(1)
			.forEach((panel: HTMLElement) => { panel.remove(); });

		const contextPanel = multipleChoice.querySelector<HTMLElement>('.context-panel');
		const context = contextPanel.querySelector('.context');
		if (content.contexts.length > 0) {
			context.innerHTML = content.contexts[0].content_html;
			context.classList.remove('d-none');
			contextPanel.dataset.context = content.contexts[0].id;
			contextPanel.classList.remove('d-none');
			content.contexts.slice(1).reverse().forEach(_context => {
				const panel = contextPanel.cloneNode(true) as HTMLElement;
				const context = panel.querySelector('.context');
				context.innerHTML = _context.content_html;
				context.classList.remove('d-none');
				panel.dataset.context = _context.id;
				panel.classList.remove('d-none');
				panel.addEventListener('click', e => {
					bindTarget.dispatchEvent(new ToggleContextsEvent([panel.dataset.context]));
				});
				contextPanel.after(panel);
			});
		} else {
			context.innerHTML = '';
			context.classList.add('d-none');
			contextPanel.removeAttribute('data-context');
			contextPanel.classList.add('d-none');
		}

		const answers = multipleChoice.querySelector('.answers');
		const answerTemplate = answers.querySelector('.answer')
			.cloneNode(true);
		answers.innerHTML = '';
		content.multiplechoice.answers.forEach((answerContent, index) => {
			const answerNode = answerTemplate.cloneNode(true) as HTMLElement;

			const input = answerNode.querySelector<HTMLInputElement>('input[name=answer]');
			const label = answerNode.querySelector('label');
			const container = answerNode.querySelector('.content');
			container.innerHTML = answerContent.content;
			input.id = 'answer-' + answerContent.name;
			input.value = answerContent.name;
			label.setAttribute('for', 'answer-' + answerContent.name);

			answers.appendChild(answerNode);
		});
	}

	displayItemSelectedAnswer(content: ContentItem<I>, bindTarget: EventTarget, answer: MultipleChoiceAnswer | undefined): void {
		const multipleChoice = document.querySelector('.item .multiplechoice');

		const answers = multipleChoice.querySelector('.answers');

		content.multiplechoice.answers.forEach((answerContent, index) => {
			const answerNode = answers.children[index];

			const input = answerNode.querySelector<HTMLInputElement>('input[name=answer]');
			const label = answerNode.querySelector('label');

			input.addEventListener('change', e => {
				bindTarget.dispatchEvent(new AnswerEvent(answerContent.name));
			});
			input.checked = answer === answerContent.name;

			if (answer === answerContent.name) {
				label.classList.add('border', 'rounded', 'bg-light');
			} else {
				label.classList.remove('border', 'rounded', 'bg-light');
			}
		});
	}

	displayItemReview(content: ContentItem<I>, answer: MultipleChoiceAnswer | undefined): void {
		const multipleChoice = document.querySelector('.item .multiplechoice');

		const explanation = multipleChoice.querySelector('.explanation');
		explanation.innerHTML = content.multiplechoice.explanation;

		const explanationPanel = explanation.closest('div.card');
		const correct = document.querySelector('.correct');
		const correctAnswer = content.multiplechoice.answers
			.filter(answerContent => answerContent.correct)[0];
		if (answer === correctAnswer.name) {
			correct.innerHTML = 'Correct';
			correct.classList.remove('alert-danger', 'alert-info');
			correct.classList.add('alert-success');
			explanationPanel.classList.remove('border-danger', 'border-info');
			explanationPanel.classList.add('border-success');
		} else if (answer) {
			correct.innerHTML = 'Incorrect';
			correct.classList.remove('alert-success', 'alert-info');
			correct.classList.add('alert-danger');
			explanationPanel.classList.remove('border-success', 'border-info');
			explanationPanel.classList.add('border-danger');
		} else {
			correct.innerHTML = 'Unanswered';
			correct.classList.remove('alert-success', 'alert-danger');
			correct.classList.add('alert-info');
			explanationPanel.classList.remove('border-success', 'border-danger');
			explanationPanel.classList.add('border-info');
		}

		const answers = multipleChoice.querySelector('.answers');

		content.multiplechoice.answers.forEach((answerContent, index) => {
			const answerNode = answers.children[index];

			const label = answerNode.querySelector('label');
			const name = answerNode.querySelector('.name');

			if (name) {
				name.innerHTML = answerContent.name + '.';
			}

			const correct = answerNode.querySelector('.correct');
			if (answerContent.correct) {
				label.classList.remove('border-danger');
				label.classList.add('border-success');
				correct.classList.remove('d-none');
			} else if (answer === answerContent.name) {
				label.classList.remove('border-success');
				label.classList.add('border-danger');
				correct.classList.add('d-none');
			} else {
				label.classList.remove('border-success', 'border-danger');
				correct.classList.add('d-none');
			}
		});
	}

	displayItemRendered(content: ContentItem<I>, mathjax: MathJaxObject): void {
		const multipleChoice = document.querySelector('.item .multiplechoice');
		mathjax.typesetPromise().then(() => {
			multipleChoice.classList.remove('invisible');
		});
	}

	displayItemAlerts(content: ContentItem<I>): void {
		// Do nothing.
		return;
	}
}